/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const convertInventoryDataSchema = z.object({
	inventoryItemIds: z.array(z.string()),
	customFields: z.array(z.object({ id: z.string().uuid(), value: z.string() })).optional(),
	billingProfileId: z.string().uuid().nullable().optional(),
})

export type ConvertInventoryDataSchema = z.infer<typeof convertInventoryDataSchema>
